<template>

  <b-overlay
    :show="showOverlay"
    rounded="sm"
  >

    <locations-list-add-new
      :is-add-new-locations-sidebar-active.sync="isAddNewLocationsSidebarActive"
      :organisation-options="organisationOptions"
      @refetch-data="refetchLocationsData"
    />

    <template>

      <b-row>

        <b-col
          cols="12"
          xl="12"
          lg="12"
          md="12"
        >

          <template>

            <!-- Table Container Card -->
            <b-card
              no-body
            >

              <div class="m-2">
                <!-- Table Top -->
                <b-row>
                  <!-- Per Page -->
                  <b-col
                    cols="12"
                    md="6"
                    class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                  >
                    <label>Entries</label>
                    <v-select
                      v-model="perPage"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="perPageOptions"
                      :clearable="false"
                      class="per-page-selector d-inline-block ml-50 mr-1"
                    />
                  </b-col>
                  <!-- Add -->
                  <b-col
                    class="d-flex align-items-center justify-content-end"
                    cols="12"
                    md="6"
                  >
                    <b-button
                      v-if="$can('create', 'location')"
                      variant="primary"
                      @click="isAddNewLocationsSidebarActive = true"
                    >
                      Toevoegen
                    </b-button>
                  </b-col>
                </b-row>
              </div>
              <b-table
                ref="refLocationsListTable"
                :items="fetchLocations"
                responsive
                :fields="tableColumns"
                primary-key="id"
                :sort-by.sync="sortBy"
                :sort-desc.sync="isSortDirDesc"
                show-empty
                empty-text="Geen overeenkomende records gevonden"
                class="position-relative categorie-table"
              >

                <!-- Column: Id -->
                <template #cell(id)="data">
                  <!--                  <b-link-->
                  <!--                    :to="{ name: 'app-locations-edit', params: { id: data.item.id }}"-->
                  <!--                    class="font-weight-bold"-->
                  <!--                  >-->
                  #{{ data.value }}
                  <!--                  </b-link>-->
                </template>

                <template #cell(companyID)="data">
                  <div class="text-nowrap">
                    <span class="align-text-top text-capitalize">{{ resolveOrganisationName(data.item.companyID) }}</span>
                  </div>
                </template>

                <!-- Column: Actions -->
                <template #cell(actions)="data">

                  <div class="text-nowrap">
                    <b-link
                      v-if="$can('update', 'location')"
                      :id="`location-view-action-row-${data.item.id}`"
                      :to="{ name: 'app-locations-edit', params: { id: data.item.id }}"
                    >
                      <feather-icon
                        :id="`location-row-${data.item.id}-preview-icon`"
                        class="cursor-pointer mx-1"
                        icon="EyeIcon"
                        size="16"
                      />
                    </b-link>
                    <b-tooltip
                      :target="`location-view-action-row-${data.item.id}`"
                      placement="top"
                    >
                      <p class="mb-0">
                        Aanpassen
                      </p>
                    </b-tooltip>
                    <feather-icon
                      v-if="$can('update', 'location')"
                      :id="`location-row-${data.item.id}-delete-icon`"
                      class="cursor-pointer"
                      size="16"
                      icon="TrashIcon"
                      @click="confirmLocationDeleteText(data.item.id)"
                    />
                    <b-tooltip
                      :target="`location-row-${data.item.id}-delete-icon`"
                      placement="top"
                    >
                      <p class="mb-0">
                        Verwijderen
                      </p>
                    </b-tooltip>
                  </div>
                </template>

              </b-table>
              <div class="mx-2 mb-2">
                <b-row>

                  <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-start"
                  >
                    <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                  </b-col>
                  <!-- Pagination -->
                  <b-col
                    cols="12"
                    sm="6"
                    class="d-flex align-items-center justify-content-center justify-content-sm-end"
                  >

                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalLocations"
                      :per-page="perPage"
                      first-number
                      last-number
                      class="mb-0 mt-1 mt-sm-0"
                      prev-class="prev-item"
                      next-class="next-item"
                    >
                      <template #prev-text>
                        <feather-icon
                          icon="ChevronLeftIcon"
                          size="18"
                        />
                      </template>
                      <template #next-text>
                        <feather-icon
                          icon="ChevronRightIcon"
                          size="18"
                        />
                      </template>
                    </b-pagination>

                  </b-col>

                </b-row>
              </div>
            </b-card>

          </template>

        </b-col>

      </b-row>

    </template>

  </b-overlay>

</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BTable,
  BLink, BTooltip, BOverlay, BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { onUnmounted, ref } from '@vue/composition-api'
import useLocationsList from '@/views/pages/locations/useLocationsList'
import locationsStoreModule from '@/views/pages/locations/locationsStoreModule'
import LocationsListAddNew from '@/views/pages/locations/locations-add/LocationsListAddNew.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import errorDefaultMessage from '@core/app-config/errorAndSuccesDefaultMessage'

export default {
  components: {
    LocationsListAddNew,
    BRow,
    BCol,
    BCard,
    BButton,
    BTable,
    BLink,
    vSelect,
    BTooltip,
    BOverlay,
    BPagination,
  },
  data() {
    return {
      organisationOptions: [],
    }
  },
  beforeMount() {
    this.getOrganisations()
  },
  methods: {
    resolveOrganisationName(id) {
      if (this.organisationOptions.find(org => org.id === id)) {
        return this.organisationOptions.find(org => org.id === id).name
      }

      return ''
    },
    getOrganisations() {
      store
        .dispatch('app-locations-list/fetchOrganisations', {
          sortBy: 'name',
          sortDesc: false,
        })
        .then(response => {
          this.organisationOptions = response.data.items
        })
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Ophalen organisaties',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: `${errorDefaultMessage.fetchDataError}`,
            },
          })
        })
    },
    confirmLocationDeleteText(id) {
      this.$swal({
        title: 'Weet je het zeker?',
        text: 'U kunt dit niet meer terugdraaien!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, verwijder het!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          store.dispatch('app-locations-list/deleteLocation', { id })
            .then(() => {
              this.refetchLocationsData()
              this.$swal({
                icon: 'success',
                title: 'Verwijderd!',
                text: 'De locatie is verwijderd.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
        }
      })
    },
  },
  setup() {
    const LOCATIONS_APP_STORE_MODULE_NAME = 'app-locations-list'

    // Register module
    if (!store.hasModule(LOCATIONS_APP_STORE_MODULE_NAME)) store.registerModule(LOCATIONS_APP_STORE_MODULE_NAME, locationsStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(LOCATIONS_APP_STORE_MODULE_NAME)) store.unregisterModule(LOCATIONS_APP_STORE_MODULE_NAME)
    })

    const isAddNewLocationsSidebarActive = ref(false)

    const {
      fetchLocations,
      tableColumns,
      perPage,
      currentPage,
      totalLocations,
      dataMeta,
      perPageOptions,
      isSortDirDesc,
      sortBy,
      refLocationsListTable,
      refetchLocationsData,
      showOverlay,
    } = useLocationsList()

    return {
      isAddNewLocationsSidebarActive,
      fetchLocations,
      tableColumns,
      perPage,
      currentPage,
      totalLocations,
      dataMeta,
      perPageOptions,
      sortBy,
      isSortDirDesc,
      refLocationsListTable,
      refetchLocationsData,
      showOverlay,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }

  .categorie-table{
    .description{
      width:30%;
    }
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
